// Frontend port of the minimal attitude scoring helpers from backend/src/attitudesConfig.js
// Only implements what the UI needs: getActiveIndicatorConfig, computeAttitudeDetails

const INDICATOR_ATTITUDE_CONFIG = [
  { indicator: "Conscientiousness_for_Qualite", attitude: "Qualite", polarity: 1, weightPercent: 18, backendKey: "conscientiousness", group: "core" },
  { indicator: "Prudence_SensationForte_RS", attitude: "Qualite", polarity: 1, weightPercent: 12, backendKey: "excitementSeeking", group: "core" },
  { indicator: "MaitriseDeSoi_Impulsivite_RS", attitude: "Qualite", polarity: 1, weightPercent: 12, backendKey: "impulsivity", group: "core" },
  { indicator: "Style cognitif", attitude: "Qualite", polarity: 1, weightPercent: 36, backendKey: "styleCognitif", group: "core" },
  { indicator: "RegulationEmotionnelle_RS", attitude: "Qualite", polarity: 1, weightPercent: 12, backendKey: "affectRegulation", group: "core" },
  { indicator: "SecuriteEmploi_RS", attitude: "Qualite", polarity: 1, weightPercent: 5, backendKey: "security", group: "core" },
  { indicator: "PenseeMagique_RS_opt", attitude: "Qualite", polarity: -1, weightPercent: 5, backendKey: "wishfulThinking", group: "core", optional: true },
  { indicator: "Agreabilite_Agressivite_RS", attitude: "Respect", polarity: 1, weightPercent: 22, backendKey: "aggressiveness", group: "core" },
  { indicator: "EspritCooperatif_EspritDominant_RS", attitude: "Respect", polarity: 1, weightPercent: 12, backendKey: "espritCooperatif_EspritDominant", group: "core" },
  { indicator: "MaitriseDeSoi_Impulsivite_RS", attitude: "Respect", polarity: 1, weightPercent: 12, backendKey: "impulsivity", group: "core" },
  { indicator: "RegulationEmotionnelle_RS", attitude: "Respect", polarity: 1, weightPercent: 12, backendKey: "affectRegulation", group: "core" },
  { indicator: "Affection_RS", attitude: "Respect", polarity: 1, weightPercent: 6, backendKey: "affection", group: "core" },
  { indicator: "Harmonie_RS", attitude: "Respect", polarity: 1, weightPercent: 6, backendKey: "harmony", group: "core" },
  { indicator: "Moralite_RS", attitude: "Respect", polarity: 1, weightPercent: 10, backendKey: "morality", group: "core" },
  { indicator: "Integrite_RS", attitude: "Respect", polarity: 1, weightPercent: 10, backendKey: "integrity", group: "core" },
  { indicator: "Introversion_Extraversion_RS", attitude: "Cooperation", polarity: 1, weightPercent: 16, backendKey: "extraversion", group: "core" },
  { indicator: "EspritCooperatif_EspritDominant_RS", attitude: "Cooperation", polarity: 1, weightPercent: 18, backendKey: "espritCooperatif_EspritDominant", group: "core" },
  { indicator: "Agreabilite_Agressivite_RS", attitude: "Cooperation", polarity: 1, weightPercent: 16, backendKey: "aggressiveness", group: "core" },
  { indicator: "Expressivite_RS", attitude: "Cooperation", polarity: 1, weightPercent: 10, backendKey: "expressiveness", group: "core" },
  { indicator: "RegulationEmotionnelle_RS", attitude: "Cooperation", polarity: 1, weightPercent: 10, backendKey: "affectRegulation", group: "core" },
  { indicator: "Resilience_RS", attitude: "Cooperation", polarity: 1, weightPercent: 10, backendKey: "stressResilience", group: "core" },
  { indicator: "Affection_RS", attitude: "Cooperation", polarity: 1, weightPercent: 6, backendKey: "affection", group: "core" },
  { indicator: "Harmonie_RS", attitude: "Cooperation", polarity: 1, weightPercent: 6, backendKey: "harmony", group: "core" },
  { indicator: "Introversion_Extraversion_RS", attitude: "Engagement", polarity: 1, weightPercent: 16, backendKey: "extraversion", group: "core" },
  { indicator: "Optimisme_Pessimisme_RS", attitude: "Engagement", polarity: 1, weightPercent: 16, backendKey: "pessimism", group: "core" },
  { indicator: "DouteDeSoi_ConfianceEnSoi_RS", attitude: "Engagement", polarity: 1, weightPercent: 12, backendKey: "selfAssurance", group: "core" },
  { indicator: "Desinvolture_Consciencieux_RS", attitude: "Engagement", polarity: 1, weightPercent: 12, backendKey: "conscientiousness", group: "core" },
  { indicator: "Resilience_RS", attitude: "Engagement", polarity: 1, weightPercent: 12, backendKey: "stressResilience", group: "core" },
  { indicator: "Expressivite_RS", attitude: "Engagement", polarity: 1, weightPercent: 8, backendKey: "expressiveness", group: "core" },
  { indicator: "PlaisirTravail_RS", attitude: "Engagement", polarity: 1, weightPercent: 8, backendKey: "enjoyWork", group: "core" },
  { indicator: "StimulationIntellectuelle_RS", attitude: "Engagement", polarity: 1, weightPercent: 8, backendKey: "intellectualStimulation", group: "core" },
  { indicator: "TachesVariees_RS", attitude: "Engagement", polarity: 1, weightPercent: 8, backendKey: "taskVariability", group: "core" },
  { indicator: "Prudence_SensationForte_RS", attitude: "Ouverture", polarity: -1, weightPercent: 20, backendKey: "excitementSeeking", group: "core" },
  { indicator: "Introversion_Extraversion_RS", attitude: "Ouverture", polarity: 1, weightPercent: 12, backendKey: "extraversion", group: "core" },
  { indicator: "TachesVariees_RS", attitude: "Ouverture", polarity: 1, weightPercent: 12, backendKey: "taskVariability", group: "core" },
  { indicator: "StimulationIntellectuelle_RS", attitude: "Ouverture", polarity: 1, weightPercent: 16, backendKey: "intellectualStimulation", group: "core" },
  { indicator: "RegulationEmotionnelle_RS", attitude: "Ouverture", polarity: 1, weightPercent: 10, backendKey: "affectRegulation", group: "core" },
  { indicator: "Resilience_RS", attitude: "Ouverture", polarity: 1, weightPercent: 10, backendKey: "stressResilience", group: "core" },
  { indicator: "Optimisme_Pessimisme_RS", attitude: "Ouverture", polarity: 1, weightPercent: 10, backendKey: "pessimism", group: "core" },
  { indicator: "SecuriteEmploi_RS", attitude: "Ouverture", polarity: -1, weightPercent: 10, backendKey: "security", group: "core" }
];

const defaultAttitudeScoringOptions = {
  useCognitiveSubscales: true,
  includeNonVerbal: true,
  includeEmotionalRedFlags: true,
};

function getActiveIndicatorConfig(options = defaultAttitudeScoringOptions) {
  return INDICATOR_ATTITUDE_CONFIG.filter((row) => {
    if (options.useCognitiveSubscales) {
      if (row.group === "core" && row.indicator === "Style cognitif") return false;
    } else {
      if (row.group === "cognitiveSubscale") return false;
    }
    if (!options.includeNonVerbal && row.group === "nonVerbal") return false;
    if (!options.includeEmotionalRedFlags && row.group === "emotionalRedFlag") return false;
    return true;
  });
}

function computeAttitudeDetails(traits, options = defaultAttitudeScoringOptions) {
  const config = getActiveIndicatorConfig(options);
  const rowsByAttitude = {
    Qualite: [],
    Respect: [],
    Cooperation: [],
    Engagement: [],
    Ouverture: [],
  };
  for (const row of config) rowsByAttitude[row.attitude]?.push(row);

  const details = {};

  for (const att of Object.keys(rowsByAttitude)) {
    const rows = rowsByAttitude[att];
    let usableTotal = 0;
    for (const r of rows) {
      if (traits[r.backendKey] != null) usableTotal += r.weightPercent;
    }
    if (usableTotal <= 0) {
      details[att] = { att, usableTotal: 0, scale: null, rows: [], sum: 0, score: 0 };
      continue;
    }
    const scale = 100 / usableTotal;
    const outRows = [];
    let sum = 0;
    for (const r of rows) {
      const value = traits[r.backendKey] ?? null;
      if (value == null) continue;
      const normalizedWeight = r.weightPercent * scale;
      const contrib = value * normalizedWeight * r.polarity;
      outRows.push({
        indicator: r.indicator,
        backendKey: r.backendKey,
        value,
        weightPercent: r.weightPercent,
        normalizedWeight,
        polarity: r.polarity,
        contrib
      });
      sum += contrib;
    }
    details[att] = {
      att,
      usableTotal,
      scale,
      rows: outRows,
      sum,
      score: sum / 100
    };
  }
  return details;
}

module.exports = {
  computeAttitudeDetails,
  defaultAttitudeScoringOptions
};
